import {
  Paper,
  Typography,
  Box,
  LinearProgress,
  Button,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { formatDuration } from "../../../utils/common";

const StyledLinearProgress = styled(LinearProgress)(
  ({ theme, progresscolor }) => ({
    height: 8,
    borderRadius: 4,
    backgroundColor: "#f0f0f0",
    "& .MuiLinearProgress-bar": {
      borderRadius: 4,
      backgroundColor: progresscolor || "#2563EB",
    },
  })
);

const MetricItem = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  "&:last-child": {
    marginBottom: 0,
  },
}));

function ImprovementAreas({ isCurrentAgent, responseData }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const leadersToRender =
    responseData?.performanceLeaderborad?.length > 3
      ? responseData?.performanceLeaderborad?.slice(0, 3)
      : responseData?.performanceLeaderborad;

  const totalAgents = leadersToRender?.length;

  // 1. Average resolutionRate
  const avgResolutionRate =
    leadersToRender?.reduce((sum, item) => sum + item?.resolutionRate, 0) /
    totalAgents;

  // 2. Average averageSentimentScore
  const avgSentimentScore =
    leadersToRender?.reduce(
      (sum, item) => sum + item?.averageSentimentScore,
      0
    ) / totalAgents;

  // 3. Convert formattedHandlingTime to seconds
  const timeToSeconds = (timeStr) => {
    const [hh, mm, ss] = timeStr?.split(":")?.map(Number);
    return hh * 3600 + mm * 60 + ss;
  };

  const avgHandlingSeconds =
    leadersToRender?.reduce(
      (sum, item) => sum + timeToSeconds(item?.formattedHandlingTime),
      0
    ) / totalAgents;

  // Convert seconds back to HH:mm:ss
  const secondsToHHMMSS = (totalSeconds) => {
    const hh = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
    const mm = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, "0");
    const ss = String(Math.floor(totalSeconds % 60)).padStart(2, "0");
    return `${hh}:${mm}:${ss}`;
  };
  const avgFormattedHandlingTime = secondsToHHMMSS(avgHandlingSeconds);

  const improvementData = [
    {
      title: "Sentiment Score",
      value: isCurrentAgent?.averageSentimentScore
        ? `${isCurrentAgent?.averageSentimentScore}%`
        : 0,
      percentage: isCurrentAgent?.averageSentimentScore
        ? isCurrentAgent?.averageSentimentScore
        : 0,
      benchmark: `Top performers average ${Math.round(avgSentimentScore)}`,
      color: "#6366F1",
    },
    // {
    //   title: "Resolution Rate",
    //   value: isCurrentAgent?.resolutionRate
    //     ? `${isCurrentAgent?.resolutionRate}%`
    //     : 0,
    //   percentage: isCurrentAgent?.resolutionRate
    //     ? `${isCurrentAgent?.resolutionRate}`
    //     : 0,
    //   benchmark: `Top performers average ${Math.round(avgResolutionRate)}%`,
    //   color: "#6366F1",
    // },
    {
      title: "Average Handle Time",
      value: isCurrentAgent?.formattedHandlingTime
        ? formatDuration(isCurrentAgent?.formattedHandlingTime)
        : "0",
      percentage: isCurrentAgent?.formattedHandlingTime
        ? timeToSeconds(isCurrentAgent?.formattedHandlingTime)
        : "",
      benchmark: `Top performers average ${formatDuration(
        avgFormattedHandlingTime
      )}`,
      color: "#EAB308",
    },
  ];

  return (
    <Paper
      elevation={0}
      sx={{ p: 3, borderRadius: 3, border: "1px solid #e0e0e0" }}
    >
      <Typography
        variant={isMobile ? "h6" : "h6"}
        component="h3"
        fontWeight="600"
        color="text.primary"
        gutterBottom
        sx={{ fontSize: "1.125rem" }}
      >
        Areas for Improvement
      </Typography>

      <Box sx={{ mt: 3 }}>
        {improvementData.map((metric, index) => (
          <MetricItem key={index}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 1,
              }}
            >
              <Typography variant="body2" fontWeight="500" color="text.primary">
                {metric?.title}
              </Typography>
              <Typography variant="body2" fontWeight="600" color="text.primary">
                {metric?.value}
              </Typography>
            </Box>

            <StyledLinearProgress
              variant="determinate"
              value={metric?.percentage}
              progresscolor={metric?.color}
            />

            <Typography
              variant="caption"
              color="text.secondary"
              sx={{
                display: "block",
                mt: 0.5,
                fontSize: isMobile ? "0.75rem" : "0.8rem",
              }}
            >
              {metric?.benchmark}
            </Typography>
          </MetricItem>
        ))}
      </Box>

      {/* <Button
        variant="contained"
        fullWidth
        sx={{
          mt: 3,
          py: 1.5,
          borderRadius: 2,
          textTransform: "none",
          fontWeight: 600,
          fontSize: isMobile ? "0.875rem" : "1rem",
          backgroundColor: "#6366F1",
          "&:hover": {
            backgroundColor: "#3C3EBB",
          },
        }}
      >
        View Suggested Tasks
      </Button> */}
    </Paper>
  );
}

export default ImprovementAreas;
